var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C7.03951 0 3.01801 4.0215 3.01801 8.982C3.01801 14.189 9.07601 21.2915 11.2415 23.6645C11.446 23.888 11.723 24 12 24C12.277 24 12.554 23.888 12.7585 23.6645C14.924 21.2915 20.982 14.189 20.982 8.982C20.982 4.0215 16.9605 0 12 0ZM12.0195 22.9905H11.98C10.112 20.944 4.01751 13.8855 4.01751 8.982C4.01801 4.5805 7.59851 1 12 1C16.4015 1 19.982 4.5805 19.982 8.982C19.982 13.8855 13.8875 20.944 12.0195 22.9905Z",
    fill: "#031434"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5C9.79451 5 8.00001 6.7945 8.00001 9C8.00001 11.2055 9.79451 13 12 13C14.2055 13 16 11.2055 16 9C16 6.7945 14.2055 5 12 5ZM12 12C10.3455 12 9.00001 10.6545 9.00001 9C9.00001 7.3455 10.3455 6 12 6C13.6545 6 15 7.3455 15 9C15 10.6545 13.6545 12 12 12Z",
    fill: "#031434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.a8a19213c430c8683a69ac1af527df7c.svg";
export { ForwardRef as ReactComponent };